
export interface Pagination {
  size: number,
  page: number,
  pages: number,
  total: number,
  elements: number,
  last: boolean
}

export enum DeDuplicateTypes {    
  GET_DEDUPLICATE_REQUEST = "@@deduplicate/GET_DEDUPLICATE_REQUEST",
  GET_DEDUPLICATE_SUCCESS = "@@deduplicate/GET_DEDUPLICATE_SUCCESS",
  GET_DEDUPLICATE_ERROR = "@@deduplicate/GET_DEDUPLICATE_ERROR",
  MERGE_DEDUPLICATE_REQUEST = "@@deduplicate/MERGE_DEDUPLICATE_REQUEST",
  MERGE_DEDUPLICATE_SUCCESS = "@@deduplicate/MERGE_DEDUPLICATE_SUCCESS",
  MERGE_DEDUPLICATE_ERROR = "@@deduplicate/MERGE_DEDUPLICATE_ERROR",
}

export interface DeduplicateState {
    readonly loading: boolean;
    readonly dataLoading: boolean;
    readonly list: any;
    readonly pagination: Pagination | null;
}
